import { Toggle } from '@app/components/various/Fields/Toggle';
import { isDefined } from '@app/utils/is';
import { Form } from '@typings';
import cx from 'classnames';
import React from 'react';
import { useController, UseFormRegisterReturn, useFormState } from 'react-hook-form';

import { FieldWrapper } from './FieldParts';

type SwitchProps = Omit<Partial<UseFormRegisterReturn>, 'ref'>;

interface Props extends SwitchProps, Form.FieldProps {
  name: string;
  size?: 'medium' | 'large';
  orientation?: 'vertical' | 'horizontal';
  fieldLabelClassName?: string;
}

export const ToggleField = React.forwardRef<HTMLInputElement, Props>((props, ref) => {
  const { label, name, isRequired, helpMessage, size = 'large', orientation, fieldLabelClassName, ...rest } = props;

  const errorId = React.useId();
  const describedById = React.useId();

  const {
    field: { value },
  } = useController({ name });
  const { errors } = useFormState({ name });

  const errorMessage = errors[name]?.message as string | undefined;

  return (
    <FieldWrapper
      describedById={describedById}
      helpMessage={helpMessage}
      errorId={errorId}
      errorMessage={errorMessage}
      isRequired={isRequired}
      label={label}
      orientation={orientation}
      fieldLabelClassName={fieldLabelClassName}
    >
      <span className={cx({ 'flex min-h-10 items-center': orientation === 'vertical' })}>
        <Toggle
          ref={ref}
          {...rest}
          describedById={isDefined(helpMessage) ? describedById : undefined}
          errorMessageId={isDefined(errorMessage) ? errorId : undefined}
          checked={value}
          name={name}
          size={size}
        />
      </span>
    </FieldWrapper>
  );
});
